
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-we-ship",
      function () {
        return require("private-next-pages/what-we-ship/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-we-ship"])
      });
    }
  